import {
  EducationalScreenBodyChildResultV2,
  Typenames,
} from '@varo/graphql-schema-types';
import React from 'react';
import { StyleSheet } from 'react-native';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import theme from 'shared/styles/theme';

type EligibilityContentProps = {
  body: Array<EducationalScreenBodyChildResultV2>;
};

const EligibilityContent = ({ body }: EligibilityContentProps) => {
  return (
    <>
      {body.map((item) => {
        if (item.__typename === Typenames.TextComponent) {
          return (
            <BodyBaseText
              numberOfLines={0}
              key={item.id}
              style={styles.bodyTextStyle}
            >
              {item.copy}
            </BodyBaseText>
          );
        }
        return null;
      })}
    </>
  );
};

const styles = StyleSheet.create({
  bodyTextStyle: {
    paddingBottom: theme.spacing.m,
    paddingHorizontal: theme.spacing.m,
    textAlign: 'center',
  },
});

export default EligibilityContent;
